import { Text } from "@chakra-ui/react";
import React from "react";
import { ChakraBox } from "ui/chakra-framer";
import { LightningIcon } from "ui/icons";

type BoostedTextProps = {
  isActive: boolean;
};

export function BoostedText({ isActive }: BoostedTextProps) {
  return (
    <ChakraBox
      display="flex"
      alignItems="center"
      border="2px solid"
      borderRadius="md"
      gap={1}
      fontSize="md"
      py={1}
      px={2}
      initial={{
        color: "#DBE1E8", // Base.border
        borderColor: "#DBE1E8",
        opacity: 1,
      }}
      animate={
        isActive
          ? {
              borderColor: ["#DBE1E8", "#00A341"], // [base.border, grass]
              color: ["#DBE1E8", "#00A341"],
              opacity: [0.8, 1],
              boxShadow: ["0 0 8px rgba(0, 184, 73, 0.25)", "0 0 28px rgba(0, 184, 73, 0.3)"],
              transition: {
                duration: 0.5,
                repeat: 2,
                repeatType: "reverse",
                ease: "easeInOut",
              },
            }
          : undefined
      }
    >
      <LightningIcon boxSize="14px" fill={isActive ? "grass" : "transparent"} />

      <Text textStyle="uppercase" lineHeight={1}>
        Boosted
      </Text>

      <LightningIcon boxSize="14px" fill={isActive ? "grass" : "transparent"} />
    </ChakraBox>
  );
}
